<template>
  <main class="l-main p-register set">
    <div class="l-block">
      <SetLocalNav :hasProject="hasProject" />
      <TitleRegister />
      <div class="l-block__content">
        <div class="hTitle">
          <h1>Google Search Console認証エラー</h1>
        </div>
        <div class="message">
          <Alert>アカウントの再認証を行ってください</Alert>
        </div>
        <div class="btnArea">
          <div class="form-auto">
            <Button
              variant="border"
              size="w260"
              fsize="f16"
              icon="return_gn"
              :to="{ name: 'setGSC' }"
            >
              戻る
            </Button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import SetLocalNav from '@/components/set/SetLocalNav';
import TitleRegister from '@/components/TitleRegister';

export default {
  components: {
    Alert,
    Button,
    SetLocalNav,
    TitleRegister
  },
  computed: {
    hasProject() {
      return this.$store.getters['user/hasProject'];
    }
  }
};
</script>
